import { render, staticRenderFns } from "./c_tab_radio.vue?vue&type=template&id=6473262c&scoped=true"
import script from "./c_tab_radio.vue?vue&type=script&lang=js"
export * from "./c_tab_radio.vue?vue&type=script&lang=js"
import style0 from "./c_tab_radio.vue?vue&type=style&index=0&id=6473262c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473262c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6473262c')) {
      api.createRecord('6473262c', component.options)
    } else {
      api.reload('6473262c', component.options)
    }
    module.hot.accept("./c_tab_radio.vue?vue&type=template&id=6473262c&scoped=true", function () {
      api.rerender('6473262c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_tab_radio.vue"
export default component.exports